/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
/*
*--------------------------------------------------------------------------------------------------------------------
*Enquire Button Code By SliverClouding Start
* --------------------------------------------------------------------------------------------------------------------
*/
var EnquireNow = (function(){
  var selectors = {
    formFieldProductList: 'select[name*="q26_iAm"]',
    formFieldProductOptions: 'select[name*="productOption"]'
  }
  function enquireNow(form, enquireButton){
    this.$form = document.querySelector(form);
    this.enquireButton = enquireButton;
    if(!this.$form && !this.enquireButton) return;
    this.init();
  }
  enquireNow.prototype.init = function(){
    //product page - enquiry button area
    if(this.enquireButton) this.changeProductParams();
    //Enquiry page - jotform area
    if(this.$form){
      var _this = this;
      this.fillUpFormFields();
      this.$form.querySelector(selectors.formFieldProductList).addEventListener('change', function(){
        var allOptions = this.querySelector('option[value="'+this.value+'"]').dataset.options.split(',');
        _this.populateOptionSelector(allOptions);
      });
    }    
  }
  enquireNow.prototype.changeProductParams = function(){
    var _this = this;
    document.addEventListener('variant:changed', function(event) {
      var $enquireButton = event.target.querySelector(_this.enquireButton);
      if(!$enquireButton) return;
      var variant = event.detail.variant;
      var urlPartPage = $enquireButton.getAttribute('href').split('?')[0];
      var urlPartProduct = $enquireButton.getAttribute('href').split('?')[1].split('&')[0];
      var newUrl = urlPartPage+'?'+urlPartProduct+'&option='+variant.options[0];
      $enquireButton.setAttribute('href', newUrl);
    });
  }
  enquireNow.prototype.fillUpFormFields = function(){
  	if(enquiryProductListHtml == '' || typeof enquiryProductListHtml == 'undefined') return;
    if(window.location.search){
      var queryParams = decodeURIComponent(window.location.search.replace('?','')).split('&');
      var selectedProductTitle = queryParams[0].split('=')[1];
      var selectedProductOption = queryParams[1].split('=')[1];
      var changeListE = new Event("change");
      this.$form.querySelector(selectors.formFieldProductList).innerHTML = enquiryProductListHtml;
      this.$form.querySelector(selectors.formFieldProductList).value = selectedProductTitle;
      this.$form.querySelector(selectors.formFieldProductList).dispatchEvent(changeListE);
      var allOptions = this.$form.querySelector(selectors.formFieldProductList+' option[value="'+selectedProductTitle+'"]').dataset.options.split(',');
      this.populateOptionSelector(allOptions, selectedProductOption);
    } else {
      this.$form.querySelector(selectors.formFieldProductList).innerHTML = '<option value="" selected disabled>Choose Product</option>'+enquiryProductListHtml;
      this.$form.querySelector(selectors.formFieldProductOptions).innerHTML = '<option value="" selected disabled>Choose Option</option>';
    }
  }
  enquireNow.prototype.populateOptionSelector = function(options, selectedVal){
    var optionTemplate = '', _this = this;
    options.forEach(function(option){
      optionTemplate += '<option value="'+option.trim()+'">'+option.trim()+'</option>';
    });
    this.$form.querySelector(selectors.formFieldProductOptions).innerHTML = optionTemplate;
    if(selectedVal){
      setTimeout(function(){
        selectedVal = selectedVal.trim();
        var changeOptionsE = new Event("change");
        _this.$form.querySelector(selectors.formFieldProductOptions).value = selectedVal;
        _this.$form.querySelector(selectors.formFieldProductOptions).dispatchEvent(changeOptionsE);
      }, 600);
    }
  }
  return enquireNow;
})();
var jotFormSelector = '#shopify-section-new-code-enquiry-template .jotform-form';
var enquireButtonSelector = '.Button--enquire';
new EnquireNow(jotFormSelector, enquireButtonSelector);
/*
*--------------------------------------------------------------------------------------------------------------------
*Enquire Button Code By SliverClouding End
* --------------------------------------------------------------------------------------------------------------------
*/